import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getToken } from 'firebase/messaging';

import { useWatchUserActions } from '../../hooks/use-watch-user-actions';
import { TIMERS } from '../../constants/timers';
import { LOCAL_STORAGE } from '../../constants/local-storage';
import { Paths } from '../../routes/paths-enum';
import { isWebContext } from '../../utils/is-web-context';
import { messaging, onMessage, vapidKey } from '../../firebase-config';
import { useLogout } from '../../hooks/use-logout';
import { usePushMessageConfirmMutation } from '../../redux/services/auth';
import { useLazyGetChatDataQuery } from '../../redux/services/chat';

export const ProtectedRoute = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const { isLogout } = useWatchUserActions();
  const [postPushConfirm] = usePushMessageConfirmMutation();
  const [getChatData] = useLazyGetChatDataQuery();
  const isSavedPush = localStorage.getItem(LOCAL_STORAGE.savedPushToken);

  const { logOut } = useLogout();

  const token = sessionStorage.getItem(LOCAL_STORAGE.isAuthorized);
  // const token = cookieParser?.[COOKIE_STORAGE.accessToken];

  useEffect(() => {
    const lastActivityTime = sessionStorage.getItem(LOCAL_STORAGE.userLastActivityTime);

    if (lastActivityTime && Date.now() - Number(lastActivityTime) >= TIMERS.LAST_ACTIVE) {
      logOut();
    } else sessionStorage.setItem(LOCAL_STORAGE.userLastActivityTime, String(Date.now()));
  }, [logOut]);

  useEffect(() => {
    if (isWebContext && (!isSavedPush || isSavedPush === 'false')) {
      getToken(messaging, { vapidKey })
        .then((fbToken) => getChatData({ token: fbToken, withPushTokenReq: true }))
        .catch(() => {});
    }
  }, [getChatData, isSavedPush]);

  useEffect(() => {
    if (isWebContext) {
      //  todo: on unauthorized zone there is no message with unsubscribe
      const unsubscribe = onMessage(messaging, (payload: any) => {
        // if (showOnStand({ stands: [StandEnum.LOCAL, StandEnum.DEV] })) {
        // eslint-disable-next-line
        console.log('Message received. ', payload);
        // }
        // eslint-disable-next-line no-new
        new Notification(payload.notification.title, payload.notification);
        const { messageId, deviceId } = { ...payload?.data };

        if (messageId && deviceId) {
          postPushConfirm({ messageId, deviceId });
        }
      });

      return () => {
        unsubscribe();
      };
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isLogout) {
      setIsVisible(false);
      logOut();
    }
  }, [isLogout, logOut]);

  useEffect(() => {
    const checkToken = setTimeout(() => {
      if (!token) {
        navigate(Paths.MAIN, { replace: true });
      }
    }, 0);

    return () => clearTimeout(checkToken);
  }, [navigate, token]);

  return token && isVisible && <Outlet />;
};
